import { render, staticRenderFns } from "./robotSetup.vue?vue&type=template&id=d456e95e&scoped=true&"
import script from "./robotSetup.vue?vue&type=script&lang=js&"
export * from "./robotSetup.vue?vue&type=script&lang=js&"
import style0 from "./robotSetup.vue?vue&type=style&index=0&id=d456e95e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d456e95e",
  null
  
)

export default component.exports